<template>
    <div>
        <vapp-header btnBack></vapp-header>
        <div class="container" style="padding-top: 15px">
            <div class="row">
                <div class="col-md-12">
                    <ul class="method-list">
                        <li v-for="(method, index) in methods" :key="index" @click="pushMethod(method)">
                            <div class="method-circle">
                                <span>{{ method.name.charAt(0).toUpperCase() }}</span>
                            </div>
                            <span>{{ method.name }}</span>
                            <hr>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as $$ from "lodash";
    import listSvc from '../../services/listService'
    import { mapState, mapActions } from 'vuex'

    export default {
        name: "SelectPaymentMethod",
        data: () => ({
            methods: [],
        }),
        computed : {
            ...mapState('invoice',['currentPaymentLine', 'isEditingInvoice']),
            ...mapState('company',['selectedCompany']),
        },
        methods : {
            ...mapActions('invoice',['setCreateInvoiceObj', 'setEditInvoicePartial']),
            pushMethod(method) {
                let partialToPush = {
                    index : this.currentPaymentLine - 1,
                    partial : {
                        method_id: method.id,
                        method_name: method.name
                    }
                };
                if (this.isEditingInvoice){
                    this.setEditInvoicePartial(partialToPush);
                } else {
                    this.setCreateInvoiceObj({ partials: partialToPush })
                }
                this.$router.go(-1);
            },
            async readMethods () {
                let methodsData = [];
                let data = {
                    "requests": [{
                        "params" : {
                            "company_id" : this.selectedCompany
                        },
                        "uri" : "/lists/methods"

                    }]
                };
                listSvc.methods.readMixed(data).then( data => {
                    this.methods = data.methods;
                });
            },
        },
        mounted () {
            console.log("Mounted : Select Payment Method");
            // this.currentPaymentLine = this.payments.length + 1;
            this.readMethods();
        }
    }
</script>

<style scoped>
    .method-list {
        padding-left:0;
        margin-bottom: 0;
    }

    .method-list li {
        cursor: pointer;
        list-style: none;
        transition: all 0.3 ease-in-out;
    }

    .method-list>li>span {
        transition: all 0.3s ease-in-out;
    }

    .method-list>li>.method-circle {
        background: #24cab7;
        border-radius: 50%;
        border: 1px solid rgba(0,0,0,0.1);
        margin-right: 15px;
        display: inline-block;
        width: 50px;
        height: 50px;
        text-align: center;
    }

    .method-list>li>.method-circle>span {
        color: white;
        text-transform: lowercase;
        line-height: 43px;
        font-size: 1.25rem;
    }

    .method-list li img {
        width: 15px;
    }
</style>
